module.exports = __webpack_public_path__ + "img/blackjack.bbbfe1f4.png";